module.exports = __webpack_public_path__ + "static/img/business22.98ba5f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business/business22.jpg
// module id = q1we
// module chunks = 9